import React from "react";
import BaseApi from '../api/BaseApi.js';

export default class MobileUploadDocScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploading: false,
            success: false,
            uploadedCount: 0,
            error: null,
            eventName: null
        };

        this.fileInputRef = React.createRef();

        this.openFileDialog = this.openFileDialog.bind(this);
        this.handleFileInput = this.handleFileInput.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
    }

    componentDidMount() {
        // опционально можно загрузить инфу о событии
        // BaseApi.get("/event/photos/mobile-upload-info", {
        //     params: { token: this.props.token }
        // })
    }

    openFileDialog() {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    }

    handleFileInput(event) {
        this.handleFiles(event.target.files);
        event.target.value = "";
    }

  
    async handleFiles(fileList) {
        const files = Array.from(fileList || []);

        if (files.length === 0) {
            return;
        }

        const docFiles = files.filter(file =>
            file.type === "application/pdf"
        );

        if (docFiles.length === 0) {
            this.setState({
                error: "Можно загружать только PDF документы"
            });
            return;
        }

        this.setState({
            uploading: true,
            error: null,
            success: false
        });

        try {
        

            const formData = new FormData();
            formData.append("token", this.props.token);

            docFiles.forEach(file => {
                formData.append("files[]", file);
            });

            const response = await BaseApi.post(
                "/event/doc/mobile-upload",
                formData,
                {
                    withCredentials: false
                }
            );

            const uploadedCount =
                response &&
                response.data &&
                response.data.result &&
                response.data.result.length

            this.setState({
                uploading: false,
                success: true,
                uploadedCount
            });

        } catch (error) {
            console.log(error);

            this.setState({
                uploading: false,
                error: "Не удалось загрузить документы"
            });
        }
    }

    render() {
        return (
            <div
                className="container"
                style={{
                    maxWidth: "500px",
                    paddingTop: "40px"
                }}
            >
                <div className="card shadow-sm">
                    <div className="card-body text-center">

                        <h4 className="mb-3">
                            Загрузка документов
                        </h4>

                        <p className="text-muted">
                            Выберите документы с телефона
                        </p>

                        <input
                            ref={this.fileInputRef}
                            type="file"
                            accept="application/pdf"
                            multiple
                            className="d-none"
                            onChange={this.handleFileInput}
                        />

                        <button
                            className="btn btn-primary btn-lg w-100"
                            onClick={this.openFileDialog}
                            disabled={this.state.uploading}
                        >
                            Выбрать документы
                        </button>

                        {this.state.uploading && (
                            <div className="mt-3 text-muted">
                                Загрузка...
                            </div>
                        )}

                        {this.state.success && (
                            <div className="alert alert-success mt-3">
                                Загружено документов: {this.state.uploadedCount}
                                <br/>
                                Можно закрыть страницу
                            </div>
                        )}

                        {this.state.error && (
                            <div className="alert alert-danger mt-3">
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
} 



// WEBPACK FOOTER //
// ./src/ui/mobile-upload-doc.js